import { Injector } from "@angular/core";
import { AutoUploadNode } from "../../AutoUploadNode";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { AttachmentEntity } from "../../../Data/MedicinalProductData/AttachmentEntity";
import { TreeNodeAttachmentList } from "../../Art57Node/ListEntity/TreeNodeAttachmentList";
import { environment } from "../../../../../../environments/environment";


export class AttachmentAutoUploadEntity extends AutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload:boolean, cloningNode: boolean) {
        const createChildTemplateparams = {nodeType:1};
        super(injector, labelTemplate, AttachmentEntity, useHist ? AutoUploadEntityEnum.attachmentHist : AutoUploadEntityEnum.attachment, ServiceEnum.MedicinalProducts, parent, model,TreeNodeAttachmentList, false, disableAutoUpload, cloningNode, createChildTemplateparams); 
        this.labelNodeName = 'Attachment';
        this.useHist = useHist; 
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
        const clonedNode = new AttachmentAutoUploadEntity(this.ioc!, this.labelTemplate, newParent, this.datasource, this.useHist, this.isLoaded, true);
        clonedNode.loadEntity();
        clonedNode.isLoading = false;

        clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
        clonedNode.refreshLabel();
        clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning || environment.userPreferences.alwaysAutoexpandNodes);

        this.children?.forEach(child => {
            const clonedChild = (child as BaseNode).cloneNode(clonedNode);
            if (clonedChild) {
                clonedNode.children?.push(clonedChild);
                clonedChild.refreshLabel();
            }
        });

        clonedNode.cloningNode = false;
        return clonedNode;
    }
}